import { API_URLS } from '_constants';
import * as TYPES from './Report.types';

export const getCalcPoly = () => ({
  types: [TYPES.GET_CALC_POLY, TYPES.GET_CALC_POLY_SUCCESS, TYPES.GET_CALC_POLY_FAIL],
  promise: (client) =>
    client.get(`${API_URLS.calcPoly}?exclude_empty_retailers=true&exclude_empty_venues=true&for_report=true`),
});

export const getAreaReport = (params) => ({
  types: [TYPES.GET_AREA_REPORT, TYPES.GET_AREA_REPORT_SUCCESS, TYPES.GET_AREA_REPORT_FAIL],
  promise: (client) => client.get(`${API_URLS.areaReport}?${params}`),
});

export const postRetailLandscapeReport = (payload) => ({
  types: [TYPES.POST_RETAIL_LANDSCAPE, TYPES.POST_RETAIL_LANDSCAPE_SUCCESS, TYPES.POST_RETAIL_LANDSCAPE_FAIL],
  promise: (client) => client.post(`${API_URLS.retailLanscape}`, payload),
});
export const postNewReport = (payload) => ({
  types: [TYPES.POST_NEW_REPORT, TYPES.POST_NEW_REPORT, TYPES.POST_NEW_REPORT_FAIL],
  promise: (client) => client.post(`${API_URLS.newReports}`, payload),
});

export const getEnforcementReport = (params) => ({
  types: [TYPES.GET_ENFORCEMENT_REPORT, TYPES.GET_ENFORCEMENT_REPORT_SUCCESS, TYPES.GET_ENFORCEMENT_REPORT_FAIL],
  promise: (client) => client.get(`${API_URLS.enforcementReport}?${params}`),
});

export const getEducationReport = (params) => ({
  types: [TYPES.GET_EDUCATION_REPORT, TYPES.GET_EDUCATION_REPORT_SUCCESS, TYPES.GET_EDUCATION_REPORT_FAIL],
  promise: (client) => client.get(`${API_URLS.educationReport}?${params}`),
});

export const getEducationForms = (params) => ({
  types: [TYPES.GET_EDUCATION_FORMS, TYPES.GET_EDUCATION_FORMS_SUCCESS, TYPES.GET_EDUCATION_FORMS_FAIL],
  promise: (client) => client.get(`${API_URLS.educationForms}?${params}`),
  visitName: 'educationForms',
});

export const getAssesmentsForms = (params) => ({
  types: [TYPES.GET_ASSESSMENTS_FORMS, TYPES.GET_ASSESSMENTS_FORMS_SUCCESS, TYPES.GET_ASSESSMENTS_FORMS_FAIL],
  promise: (client) => client.get(`${API_URLS.assessmentsForm}?${params}`),
  visitName: 'assessmentsForms',
});

export const getEnforcementForms = (params) => ({
  types: [TYPES.GET_ENFORCEMENT_FORMS, TYPES.GET_ENFORCEMENT_FORMS_SUCCESS, TYPES.GET_ENFORCEMENT_FORMS_FAIL],
  promise: (client) => client.get(`${API_URLS.enforcementForms}?${params}`),
  visitName: 'enforcementForms',
});

// export const getEnforcementAgencies = (params) => ({
//   types: [TYPES.GET_ENFORCEMENT_AGENCIES, TYPES.GET_ENFORCEMENT_AGENCIES_SUCCESS, TYPES.GET_ENFORCEMENT_AGENCIES_FAIL],
//   promise: (client) => client.get(`${API_URLS.enforcementAgencies}?${params}`),
// });

export const resetCalcPoly = () => ({
  type: TYPES.RESET_CALC_POLY,
});
